<template>
  <div class="ba-flex ba-items-center">
    <div class="ba-flex ba-justify-center ba-items-center ba-flex-shrink-0 ba-w-10 ba-h-10 ba-bg-background-light ba-rounded-full ba-overflow-hidden ba-select-none">
      <img
        v-if="user.photo"
        :src="`/img/avatars/${user.photo}.jpg`"
        :alt="user.name"
        width="40"
        height="40"
        class="ba-w-full ba-h-full ba-object-cover"
      >
      <span
        v-else
        class="ba-m-auto ba-uppercase ba-text-text-blue-grey"
      >
        {{ user.initials }}
      </span>
    </div>
    <div class="ba-ml-2">
      <p class="ba-leading-none ba-text-inherit">{{ user.name }}</p>
      <p v-if="date" class='ba-font-normal ba-text-text-blue-grey'>
        <span class="ba-mr-1">{{ date }}</span>
        <span>{{ time }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "vis-approval-queue-user",
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    date: {
      type: String,
      default: null
    },
    time: {
      type: String,
      default: null
    }
  }
}
</script>
